module.exports = __webpack_public_path__ + "static/united-way@2x-8bcbc4f17e17a05684a819231202eb27.png";